import { apiClient } from "../src/lib/api-client";
import {
  RecruitmentSourceSchema,
  SourceListResponseSchema,
  DeleteSourceResponseSchema,
  type RecruitmentSource,
} from "@applicant-reviewer/api";

export type { RecruitmentSource as ApiRecruitmentSource };

const SourcesService = {
  list(campaignId: string) {
    return apiClient.get(`/campaigns/${campaignId}/sources`, SourceListResponseSchema);
  },

  create(campaignId: string, payload: Record<string, unknown>) {
    return apiClient.post(`/campaigns/${campaignId}/sources`, RecruitmentSourceSchema, payload);
  },

  update(campaignId: string, sourceId: string, payload: Record<string, unknown>) {
    return apiClient.put(`/campaigns/${campaignId}/sources/${sourceId}`, RecruitmentSourceSchema, payload);
  },

  remove(campaignId: string, sourceId: string) {
    return apiClient.delete(`/campaigns/${campaignId}/sources/${sourceId}`, DeleteSourceResponseSchema);
  },
};

export default SourcesService;
